import React from 'react';

export const EnergyLogo = ({ innerFill = 'white', outerFill = '#0C111D' }) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="10" fill="var(--energy-icon-color)" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.3583 14.6581C36.6023 14.7939 36.7938 15.0076 36.9022 15.2649C37.0107 15.5223 37.0298 15.8086 36.9566 16.0781L33.6366 28.2498H45.7499C45.9935 28.2498 46.2318 28.321 46.4355 28.4546C46.6392 28.5882 46.7994 28.7784 46.8964 29.0019C46.9934 29.2253 47.0231 29.4723 46.9816 29.7123C46.9402 29.9524 46.8296 30.1751 46.6633 30.3531L29.1633 49.1031C28.9726 49.3078 28.7189 49.4426 28.4426 49.486C28.1664 49.5294 27.8835 49.479 27.6393 49.3427C27.3951 49.2064 27.2036 48.9921 27.0956 48.7341C26.9875 48.4762 26.9691 48.1894 27.0433 47.9198L30.3633 35.7498H18.2499C18.0063 35.7497 17.768 35.6786 17.5643 35.5449C17.3607 35.4113 17.2005 35.2211 17.1034 34.9976C17.0064 34.7742 16.9768 34.5273 17.0182 34.2872C17.0596 34.0472 17.1703 33.8244 17.3366 33.6464L34.8366 14.8964C35.0272 14.6925 35.2806 14.5583 35.5564 14.5151C35.8321 14.4719 36.1144 14.5222 36.3583 14.6581Z"
        fill="var(--energy-icon-fill-color)"
      />
    </svg>
  );
};
